
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 1624"}},[_c('path',{attrs:{"data-name":"Rectangle 2358","fill":"none","d":"M0 0h20v20H0z"}}),_c('g',{attrs:{"data-name":"Group 1634","transform":"translate(-857.779 -462.323)"}},[_c('rect',{attrs:{"data-name":"Rectangle 2359","width":"14","height":"20","rx":"1","transform":"translate(857.779 462.323)","fill":"#adadad"}}),_c('rect',{attrs:{"data-name":"Rectangle 2360","width":"3","height":"3","rx":"1","transform":"translate(860.779 465.323)","fill":"#fff"}}),_c('rect',{attrs:{"data-name":"Rectangle 2361","width":"3","height":"3","rx":"1","transform":"translate(865.779 465.323)","fill":"#fff"}}),_c('rect',{attrs:{"data-name":"Rectangle 2362","width":"3","height":"3","rx":"1","transform":"translate(865.779 470.323)","fill":"#fff"}}),_c('rect',{attrs:{"data-name":"Rectangle 2363","width":"3","height":"3","rx":"1","transform":"translate(860.779 470.323)","fill":"#fff"}}),_c('rect',{attrs:{"data-name":"Rectangle 2364","width":"3","height":"3","rx":"1","transform":"translate(860.779 475.323)","fill":"#fff"}}),_c('path',{attrs:{"data-name":"Path 1000","d":"M877.486 474.616l-4-4a1 1 0 00-1.414 1.414l2.293 2.293h-6.586a1 1 0 000 2h6.586l-2.293 2.293a1 1 0 101.414 1.414l4-4a1 1 0 000-1.414z"}})])])])
          )
        }
      }
    